@if (!authService.hasPermission(Permission.ProductsWorkflowFilter) && authService.hasPermission(Permission.OutputsCollectionsRead)) {
  <h3 class="title">Latest Output Collections</h3>
  @for (
    e of [].constructor(
    latestCollections.length < 2 ? latestCollections.length : 2
    ); track
    $index; let i = $index) {
    <div
      class="outputs-collection"
      >
      <div class="header">
        <h4 style="padding: 0 6px; padding-top: 6px">
          {{ latestCollections[i].jobNumber }} ({{
          latestCollections[i].jobName
          }}) -
          <i
            >Collection {{ latestCollections[i].index + 1 }} - Product Count:
            {{ latestCollections[i].productIds.length }}, Asset Count:
            {{ latestCollections[i].outputAssetsCount }}</i
            >
          </h4>
          <span class="spacer"></span>
          <div
            class="status-text"
            matTooltipPosition="above"
        [ngClass]="{
                complete: latestCollections[i].downloadArchiveUrl != null,
                info: latestCollections[i].downloadArchiveUrl == null,
              }"
            >
            {{
            latestCollections[i].downloadArchiveUrl == null
            ? "Zipping Collection"
            : "Ready To Download"
            }}
          </div>
          <div style="padding: 8px">
            <button
              mat-icon-button
              matTooltip="Download Collection"
              [disabled]="latestCollections[i].downloadArchiveUrl == null"
          (click)="
            downloadCollection(
              latestCollections[i].downloadArchiveUrl,
              latestCollections[i].id!
            )
          "
              >
              <mat-icon>download</mat-icon>
            </button>
            <button
              mat-icon-button
              matTooltip="Products List"
              (click)="manageCollection(latestCollections[i].id!)"
              >
              <mat-icon color="info">view_list</mat-icon>
            </button>
          </div>
        </div>
        <div class="product-list">
          <mat-grid-list
            [cols]="colPerScreen"
            [rowHeight]="'1:1'"
            gutterSize="10"
            style="flex: 1"
            >
            @for (
              e of [].constructor(
              latestCollections[i].products!.length < colPerScreen
              ? latestCollections[i].products!.length
              : colPerScreen
              ); track
              $index; let j = $index) {
              <mat-grid-tile [colspan]="1">
                <div class="product-item" #pdItem>
                  <app-dashboard-card
                    [latestAction]="latestCollections[i].createdAt"
                    [data]="latestCollections[i]!.products![j]!"
                  ></app-dashboard-card>
                </div> </mat-grid-tile>
              }</mat-grid-list>
            </div>
          </div>
        }
      }
